import React from "react";
import { Button, Col, Container, Nav, Row } from "react-bootstrap";

export default function Forbidden() {

  document.body.classList.remove("sidebar-show");
 
 document.body.className="forbiden";

  return (
    <div className="page-error">
      <div className="header">
        <Container>
          <a href="/" className="sidebar-logo"><img className="img-fluid w-50" src="/images/vindr_logo_black.svg" alt=""/></a>
        </Container>
      </div>

      <div className="content">
        <Container>
          <Row className="gx-5">
            <Col lg="12" className="d-flex flex-column align-items-center">
              <h1 className="error-number">302</h1>
              <h2 className="error-title">Forbidden</h2>
              <p className="error-text">Oopps. Something is wrong. You don't have permission to access this page.</p>
              <a href="/login"><Button variant="primary" className="btn-error">Back to login</Button></a>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}